import { render, staticRenderFns } from "./CustomerFactoringListItem.vue?vue&type=template&id=1bff34d2&lang=pug&"
import script from "./CustomerFactoringListItem.vue?vue&type=script&lang=js&"
export * from "./CustomerFactoringListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports